exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ef-cell-group-top[data-v-cd452278] {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: flex;\r\n  -webkit-flex-wrap: wrap;\r\n          flex-wrap: wrap;\n}\n.ef-cell-group-top-title[data-v-cd452278] {\r\n  /* display: flex;\r\n  flex-wrap: wrap; */\r\n  -webkit-box-flex: 1;\r\n  -webkit-flex: 1;\r\n  flex: 1;\n}\r\n", ""]);

// exports
